module.exports = __webpack_public_path__ + "img/南宁华美.3c77807.png";